// Simple audio URL versioning for automatic cache invalidation
// When new audio files are uploaded, they automatically get new timestamps
// This ensures the browser cache is automatically invalidated

export const getVersionedAudioUrl = (baseUrl) => {
  // Use current timestamp as version
  // In production, you could use file upload timestamp or file hash
  const timestamp = Date.now();
  const versionedUrl = `${baseUrl}?v=${timestamp}`;
  
  // Debug logging
  console.log('🎵 Audio URL Versioning:', {
    original: baseUrl,
    versioned: versionedUrl,
    timestamp: timestamp
  });
  
  return versionedUrl;
};

// Alternative: Use file modification time if available
export const getVersionedAudioUrlWithTimestamp = (baseUrl, fileTimestamp) => {
  const version = fileTimestamp || Date.now();
  return `${baseUrl}?v=${version}`;
};

// Test function to verify versioning works
export const testAudioVersioning = () => {
  const testUrl = '/audio/test.mp3';
  const versioned1 = getVersionedAudioUrl(testUrl);
  const versioned2 = getVersionedAudioUrl(testUrl);
  
  console.log('Original URL:', testUrl);
  console.log('Versioned URL 1:', versioned1);
  console.log('Versioned URL 2:', versioned2);
  console.log('URLs are different:', versioned1 !== versioned2);
  
  return {
    original: testUrl,
    versioned1,
    versioned2,
    areDifferent: versioned1 !== versioned2
  };
};
